import React, { useEffect, useState } from "react";
import { Modal } from "../common/Modal/Modal";
import {
  LabelStyled,
  PrimaryButton,
  SecondaryButton,
  StyledInput,
  TitleStyle,
} from "../common/common.style";
import {
  useGetAllCardMarketPriceStrategyQuery,
  useGetAllCardTraderPriceStrategyQuery,
} from "../../services/myServer/priceStrategy";
import { CardMarketCardTraderSwitch } from "../CardMarketCardTraderSwitch/CardMarketCardTraderSwitch";
import { Box, FlexBox } from "../primitives";
import { StrategyCard } from "../StrategyCard/StrategyCard";
import { LoadingOverlay } from "../common/LoadingOverley/LoadingOverley";
import {
  useBatchPriceCardsCardMarket,
  useBatchPriceCardsCardMarketTrendPrice,
  useBatchPriceCardsCardTrader,
} from "../../hooks/useBatchPrices";
import { CardSelected } from "../../type";
import toast from "react-hot-toast";
import { CheckBox } from "../common/CheckBox/CheckBox";
import { StrategyCardContainer } from "../StrategyCard/StrategyCard.styled";

interface ModalChooseStrategyProps {
  setOpen: (arg1: boolean) => void;
  setCardsBoard: React.Dispatch<React.SetStateAction<CardSelected[]>>;
  cardsBoard: CardSelected[];
  cardsBoardCanDoOpeation: CardSelected[];
}

export const ModalChooseStrategy = ({
  setOpen,
  setCardsBoard,
  cardsBoard,
  cardsBoardCanDoOpeation,
}: ModalChooseStrategyProps) => {
  const [selectedStrategy, setSelectedStrategy] = useState(0);
  const [percentage, setPercentage] = useState(100);
  const [hasDecreasePercentage, setHasDecreasePercentage] = useState(false);
  const [hasIncreasePercentage, setHasIncreasePercentage] = useState(false);
  const [maximumPercentageDecreasePrice, setMaximumPercentageDecreasePrice] =
    useState(30);
  const [maximumPercentageIncreasePrice, setMaximumPercentageIncreasePrice] =
    useState(100);
  useState(30);
  const [minPrice, setMinPrice] = useState(0.2);
  const [selectedAvgStrategy, setSelectedAvgStrategy] = useState("");
  const [strategyType, setStrategyType] = useState<"cardtrader" | "cardmarket">(
    "cardtrader"
  );
  const [applyOnlyBigger, setApplyOnlyBigger] = useState(false);
  const [applyOnlySmaller, setApplyOnlySmaller] = useState(false);
  const { data: cardtraderStategy } = useGetAllCardTraderPriceStrategyQuery();
  const { data: cardmarketStategy } = useGetAllCardMarketPriceStrategyQuery();
  const avgStrategies = [
    { name: "Trend", value: "trend" },
    { name: "30 Days Avg", value: "30-days" },
    { name: "7 Days Avg", value: "7-days" },
  ];

  useEffect(() => {
    if (applyOnlyBigger) {
      setApplyOnlySmaller(false);
    }
  }, [applyOnlyBigger]);

  useEffect(() => {
    if (applyOnlySmaller) {
      setApplyOnlyBigger(false);
    }
  }, [applyOnlySmaller]);

  useEffect(() => {
    setSelectedStrategy(0);
    setSelectedAvgStrategy("");
  }, [strategyType]);

  const {
    priceCards: priceCardsCardMarket,
    isApiLoading: isApiLoadingCardMarket,
  } = useBatchPriceCardsCardMarket();

  const {
    priceCards: priceCardsCardTrader,
    isApiLoading: isApiLoadingCardTrader,
  } = useBatchPriceCardsCardTrader();

  const {
    priceCards: priceCardsCardMarketTrend,
    isApiLoading: isApiLoadingCardMarketTrend,
  } = useBatchPriceCardsCardMarketTrendPrice();

  const onConfirmPriceStrategyHandler = async () => {
    try {
      if (strategyType === "cardtrader") {
        if (selectedStrategy) {
          await priceCardsCardTrader({
            cardsBoardFiltered: cardsBoardCanDoOpeation,
            cardsBoard,
            onUpdateBoard: setCardsBoard,
            strategyId: selectedStrategy,
            applyOnlyIfGreater: applyOnlyBigger,
            applyOnlyIfSmaller: applyOnlySmaller,
            isEdit: true,
            maximumPercentageDecreasePrice: hasDecreasePercentage
              ? maximumPercentageDecreasePrice
              : undefined,
            maximumPercentageIncreasePrice: hasIncreasePercentage
              ? maximumPercentageIncreasePrice
              : undefined,
          });
        }
      } else {
        if (selectedStrategy) {
          await priceCardsCardMarket({
            cardsBoardFiltered: cardsBoardCanDoOpeation,
            cardsBoard,
            onUpdateBoard: setCardsBoard,
            strategyId: selectedStrategy,
            applyOnlyIfGreater: applyOnlyBigger,
            applyOnlyIfSmaller: applyOnlySmaller,
            isEdit: true,
            maximumPercentageDecreasePrice: hasDecreasePercentage
              ? maximumPercentageDecreasePrice
              : undefined,
            maximumPercentageIncreasePrice: hasIncreasePercentage
              ? maximumPercentageIncreasePrice
              : undefined,
          });
        }

        if (selectedAvgStrategy) {
          await priceCardsCardMarketTrend({
            cardsBoardFiltered: cardsBoardCanDoOpeation,
            cardsBoard,
            onUpdateBoard: setCardsBoard,
            selectedAvgStrategy,
            percentage,
            applyOnlyIfGreater: applyOnlyBigger,
            applyOnlyIfSmaller: applyOnlySmaller,
            minPrice,
            isEdit: true,
            maximumPercentageDecreasePrice: hasDecreasePercentage
              ? maximumPercentageDecreasePrice
              : undefined,
            maximumPercentageIncreasePrice: hasIncreasePercentage
              ? maximumPercentageIncreasePrice
              : undefined,
          });
        }
      }
      toast.success(
        "Cards has been priced succesfully please verify if any error are present"
      );
      setOpen(false);
    } catch (e) {
      toast.error("Error non pricing cards");
    }
  };

  return (
    <>
      {(isApiLoadingCardMarket ||
        isApiLoadingCardTrader ||
        isApiLoadingCardMarketTrend) && <LoadingOverlay />}
      <Modal onClose={() => setOpen(false)}>
        <TitleStyle>CHOOSE STRATEGY</TitleStyle>
        <Box css={{ marginTop: 20 }}>
          <CardMarketCardTraderSwitch
            selected={strategyType}
            setSelected={setStrategyType}
          />
        </Box>
        <FlexBox css={{ justifyContent: "center", gap: 20, marginTop: 20 }}>
          <FlexBox css={{ alignItems: "center", gap: 10 }}>
            <CheckBox
              checked={applyOnlyBigger}
              setChecked={(checked: boolean) => {
                setApplyOnlyBigger(checked);
              }}
            />
            <LabelStyled css={{ fontWeight: "normal" }}>
              Apply if result is <strong>greater</strong> than the current price
            </LabelStyled>
          </FlexBox>
          <FlexBox css={{ alignItems: "center", gap: 10 }}>
            <CheckBox
              checked={applyOnlySmaller}
              setChecked={(checked: boolean) => {
                setApplyOnlySmaller(checked);
              }}
            />
            <LabelStyled css={{ fontWeight: "normal" }}>
              Apply if result is <strong>less</strong> than the current price
            </LabelStyled>
          </FlexBox>
        </FlexBox>
        <FlexBox css={{ alignItems: "center", gap: 10, marginTop: 20 }}>
          <LabelStyled>Maximumim % decreased price</LabelStyled>
          <CheckBox
            checked={hasDecreasePercentage}
            setChecked={(checked: boolean) => {
              setHasDecreasePercentage(checked);
            }}
          />
          {hasDecreasePercentage && (
            <StyledInput
              type="number"
              step={1}
              min={1}
              value={maximumPercentageDecreasePrice}
              onChange={(e) => {
                setMaximumPercentageDecreasePrice(+e.target.value || 30);
              }}
              onKeyDown={(e) => {
                const blockedKeys = ["e", "E", "+", "-", ".", ","];
                if (blockedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              css={{ width: 100 }}
            />
          )}
          <LabelStyled>Maximumim % increase price</LabelStyled>
          <CheckBox
            checked={hasIncreasePercentage}
            setChecked={(checked: boolean) => {
              setHasIncreasePercentage(checked);
            }}
          />
          {hasIncreasePercentage && (
            <StyledInput
              type="number"
              step={1}
              min={0}
              value={maximumPercentageIncreasePrice}
              onChange={(e) => {
                setMaximumPercentageIncreasePrice(+e.target.value || 100);
              }}
              onKeyDown={(e) => {
                const blockedKeys = ["e", "E", "+", "-"];
                if (blockedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              css={{ width: 100 }}
            />
          )}
        </FlexBox>
        <Box css={{ padding: "20px" }}>
          {cardtraderStategy?.length && strategyType === "cardtrader" ? (
            <FlexBox css={{ gap: 20, flexWrap: "wrap" }}>
              {cardtraderStategy.map((strategy) => (
                <StrategyCard
                  {...strategy}
                  setSelectedStrategy={setSelectedStrategy}
                  selectedStrategy={selectedStrategy}
                />
              ))}
            </FlexBox>
          ) : null}
          <Box>
            {cardmarketStategy?.length && strategyType === "cardmarket" ? (
              <FlexBox css={{ gap: 20, flexWrap: "wrap" }}>
                {cardmarketStategy.map((strategy) => (
                  <StrategyCard
                    {...strategy}
                    setSelectedStrategy={setSelectedStrategy}
                    selectedStrategy={selectedStrategy}
                  />
                ))}
              </FlexBox>
            ) : null}
          </Box>

          {strategyType === "cardmarket" && (
            <>
              <TitleStyle css={{ margin: "20px 0", textAlign: "left" }}>
                Apply Avarage prices
              </TitleStyle>
              <FlexBox css={{ alignItems: "center", gap: 10 }}>
                <LabelStyled>Percentage: </LabelStyled>
                <StyledInput
                  type="number"
                  step={1}
                  min={1}
                  value={percentage}
                  onChange={(e) => {
                    setPercentage(+e.target.value || 100);
                  }}
                  onKeyDown={(e) => {
                    const blockedKeys = ["e", "E", "+", "-", ".", ","];
                    if (blockedKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  css={{ width: 100 }}
                />
                <LabelStyled>Min price: </LabelStyled>
                <StyledInput
                  type="number"
                  step={1}
                  min={0}
                  value={minPrice}
                  onChange={(e) => {
                    setMinPrice(+e.target.value || 100);
                  }}
                  onKeyDown={(e) => {
                    const blockedKeys = ["e", "E", "+", "-"];
                    if (blockedKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  css={{ width: 100 }}
                />
              </FlexBox>
              <FlexBox css={{ gap: 20, flexWrap: "wrap", marginTop: 20 }}>
                {avgStrategies.map((avgStrategy) => (
                  <StrategyCardContainer
                    onClick={() => {
                      setSelectedAvgStrategy(avgStrategy.value);
                    }}
                    isSelected={selectedAvgStrategy === avgStrategy.value}
                    css={{ maxWidth: 200 }}
                  >
                    {avgStrategy.name}
                  </StrategyCardContainer>
                ))}
              </FlexBox>
            </>
          )}

          <FlexBox css={{ justifyContent: "center", marginTop: 40, gap: 20 }}>
            <PrimaryButton
              isBig
              css={{ width: 140 }}
              disabled={!selectedStrategy && !selectedAvgStrategy}
              isDisabled={!selectedStrategy && !selectedAvgStrategy}
              onClick={() => {
                onConfirmPriceStrategyHandler();
              }}
            >
              START PRICING
            </PrimaryButton>
            <SecondaryButton
              isBig
              css={{ width: 140 }}
              onClick={() => setOpen(false)}
            >
              CLOSE
            </SecondaryButton>
          </FlexBox>
        </Box>
      </Modal>
    </>
  );
};
